import React from 'react';

import { DelayedSuspense } from '@lumapps/utils/components/DelayedSuspense';

const LazyContentWidgetsTranslationDialog = React.lazy(
    () =>
        import(
            /* webpackChunkName: 'content-widgets-translation-dialog' */
            './ContentWidgetsTranslationDialog'
        ),
);

export function ContentWidgetsTranslationDialog(
    props: React.ComponentProps<typeof LazyContentWidgetsTranslationDialog>,
) {
    const { isOpen } = props;
    return (
        <DelayedSuspense shouldLoad={isOpen} isDialog>
            <LazyContentWidgetsTranslationDialog {...props} />
        </DelayedSuspense>
    );
}
